export default __webpack_public_path__ + "static/media/SCW_Info_Cymraeg.b76a23ba.pdf";